import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';

@Injectable({
  providedIn: 'root'
})
export class BuscarService {

  constructor(
    private httpClient: HttpClient
  ) { }



  buscarHelpEtiquetas(filter: any): Observable<any> {
    return this.httpClient.get(environment.serviceUrl + "articulo/sp_help_eqtiquetas?tipinv=" + filter.tipinv
      + "&codart=" + encodeURIComponent(filter.codart)
      + "&codalm=" + encodeURIComponent(filter.codalm), { observe: 'response' })
  }

  buscarHelpEtiquetas_saldocero(filter: any): Observable<any> {
    return this.httpClient.get(environment.serviceUrl + "articulo/sp-help-etiquetas-inc-saldos-cero?tipinv=" + filter.tipinv
      + "&codart=" + encodeURIComponent(filter.codart)
      + "&codalm=" + encodeURIComponent(filter.codalm), { observe: 'response' })
  }



  buscarAccesos(codmod: any): Observable<any> {
    return this.httpClient.get(environment.serviceUrl + "accesos/buscar?codmod=" + encodeURIComponent(codmod), { observe: 'response' })
  }

  public almacenes(tipinv: number) {
    return this.httpClient.get(environment.serviceUrl + "almacen/buscar?tipinv=" + encodeURIComponent(tipinv), { observe: 'response' })
  }

  public tipo_impresion(tipdoc: number) {
    return this.httpClient.get(environment.serviceUrl + "documentos-formatos/buscar?tipdoc=" + encodeURIComponent(tipdoc), { observe: 'response' })
  }


  public sucursales() {
    return this.httpClient.get(environment.serviceUrl + "sucursal/buscar", { observe: 'response' })
  }

  public tipo_identidad() {
    return this.httpClient.get(environment.serviceUrl + "identidad/buscar", { observe: 'response' })
  }

  public tipo_inventario() {
    return this.httpClient.get(environment.serviceUrl + "tinventario/buscar", { observe: 'response' })
  }

  public motivos(tipdoc: number, id: string) {
    return this.httpClient.get(environment.serviceUrl + "motivo/buscar?tipdoc=" + encodeURIComponent(tipdoc) + "&id=" + encodeURIComponent(id), { observe: 'response' })
  }

  public EspecificacionesClientes(tipcli: any, limit: number, offset: number) {
    return this.httpClient.get(environment.serviceUrl + "especificaciones-genericas/interlocutor-comercial/buscar?tipcli=" + tipcli + "&limit=" + limit + "&offset=" + offset, { observe: 'response' })
  }


  public transportistas(descri: string, limit: number, offset: number) {
    return this.httpClient.get(environment.serviceUrl + "transportista/buscar?descri=" + descri + "&limit=" + limit + "&offset=" + offset, { observe: 'response' })
  }

  public documentos(codigo: number, codsuc: number) {
    return this.httpClient.get(environment.serviceUrl + "documento/buscar?codigo=" + codigo + "&codsuc=" + codsuc, { observe: 'response' })
  }

  public documentos_tipo(tipdocs: string, descri: string) {
    return this.httpClient.get(environment.serviceUrl + "documentos-tipo/buscar?tipdocs=" + tipdocs + "&descri=" + encodeURIComponent(descri), { observe: 'response' })
  }

  public libros_contables() {
    return this.httpClient.get(environment.serviceUrl + "libros-contables/tlibro/buscar", { observe: 'response' })
  }

  public libros_contables_filtrado(clase: any) {
    return this.httpClient.get(environment.serviceUrl + "libros-contables/tlibro/buscar-v2?clase=" + clase, { observe: 'response' })
  }

  public mediospago(activo: any): Observable<any> {
    return this.httpClient.get(environment.serviceUrl + "medios-pago/buscar?activo=" + activo, { observe: 'response' })
  }

  public cobradores(): Observable<any> {
    return this.httpClient.get(environment.serviceUrl + "cobrador/buscar", { observe: 'response' })
  }

  public vehiculos(): Observable<any> {
    return this.httpClient.get(environment.serviceUrl + "vehiculo/buscar", { observe: 'response' })
  }

  public ubicaciones(): Observable<any> {
    return this.httpClient.get(environment.serviceUrl + "ubicacion/buscar", { observe: 'response' })
  }

  public lugarEmision(activo: any): Observable<any> {
    return this.httpClient.get(environment.serviceUrl + "lugar-emision/buscar", { observe: 'response' })
  }

  public titulo_lista() {
    return this.httpClient.get(environment.serviceUrl + "titulo-lista/buscar", { observe: 'response' })
  }

  public tipo_personas() {
    return this.httpClient.get(environment.serviceUrl + "tpersona/buscar", { observe: 'response' })
  }

  public cliente_regimenes() {
    return this.httpClient.get(environment.serviceUrl + "cliente/regimenes", { observe: 'response' })
  }

}
